import eventImg from "../ui/img/event.jpg";
import plantsImg from "../ui/img/plants.jpg";
import bouquetImg from "../ui/img/bouquet.jpg";

export const SHOP_INFO = {
    name: "Цветочный магазин «Ваниль»",
    phone: "+7 (987) 258-81-11",
    phoneClean: "+79872588111",
    phoneRaw: "+79872588111",
    addresses: {
        bulgakovo: "с. Булгаково, ул. Дуговая, 3/3",
        ufa: "г. Уфа, Коммунистическая улица, 51"
    },
    postalCode: "450501",
    workingHours: {
        bulgakovo: "9:00 – 21:00",
        ufa: "10:00 – 22:00"
    },
    socialMedia: {
        telegram: "https://t.me/aurica2025",
        whatsapp: "https://wa.me/79872588111",
        max: "https://max.ru/u/f9LHodD0cOLONIEtUiCkyZTnH0u-2jGBNjTm9AyKzYedbVLkfjca1QMhiyc",
        vk: ""
    },
    delivery: {
        freeFrom: 3000,
        freeConditions: "При заказе от 3000₽ (в будни и непраздничные дни)",
        ufaDaily: true,
        ufaCost: "300₽ (до 3000₽, а также в выходные и праздничные дни), бесплатно от 3000₽*"
    }
};

export const ADVANTAGES = [
    {
        id: "freshness",
        icon: "HeartOutlined",
        title: "Свежесть гарантируем",
        desc: "Работаем только с проверенными поставщиками. Цветы поступают 3 раза в неделю — от фермы к вам за 48 часов.",
        shortDesc: "Цветы от фермы за 48 ч, поступление 3 раза в неделю"
    },
    {
        id: "custom-design",
        icon: "GiftOutlined",
        title: "Индивидуальный дизайн",
        desc: "Собираем букеты под ваш запрос: по фото, по цвету, по значению цветов, под характер получателя и повод.",
        shortDesc: "По фото, по смыслу, под характер — уникальный букет"
    },
    {
        id: "delivery",
        icon: "TruckOutlined",
        title: "Доставка по Булгаково и Уфе",
        desc: "Привезём к указанному часу. Бесплатная доставка от 3000₽ по Булгаково и Уфе в будни (в непраздничные дни).",
        shortDesc: "К указанному часу, бесплатно от 3000₽ (в будни)"
    },
    {
        id: "consultation",
        icon: "SmileOutlined",
        title: "Консультация флориста",
        desc: "Не знаете, что выбрать? Наш флорист бесплатно подскажет по телефону или в чате — подберём идеальный вариант.",
        shortDesc: "Бесплатно по телефону и в Telegram — подберём за 5 мин"
    },
    {
        id: "packaging",
        icon: "StarOutlined",
        title: "Транспортировочная упаковка",
        desc: "Каждый букет едет в специальном аквабоксе и коробе — цветы не помнутся и останутся свежими в пути.",
        shortDesc: "Аквабокс + коробка — цветы целые и свежие"
    },
    {
        id: "two-addresses",
        icon: "EnvironmentOutlined",
        title: "Два удобных адреса",
        desc: "С. Булгаково, ул. Дуговая 3/3 и г. Уфа, Коммунистическая 51. Забирайте сами или закажите доставку.",
        shortDesc: "Булгаково (Дуговая 3/3) и Уфа (Коммунистическая 51)"
    }
];

export const SERVICES = [
    {
        id: "bouquets",
        title: "Букеты на заказ",
        description: "Индивидуальный букет с учётом ваших предпочтений, характера и повода. Сборка по фото и бесплатная консультация флориста.",
        image: bouquetImg,
        icon: "🌸",
        features: ["Индивидуальный дизайн", "Сборка по фото за 2 часа", "Бесплатная консультация флориста"],
        url: "/bukety-na-zakaz"
    },
    {
        id: "plants",
        title: "Комнатные растения в горшках",
        description: "Зелёные друзья, которые будут радовать вас годами. Поможем подобрать неприхотливый вариант или экзотический цветок.",
        image: plantsImg,
        icon: "🌿",
        features: ["Растения для дома и офиса", "Подбор по уровню ухода", "Кашпо и аксессуары"],
        url: "/komnatnye-rasteniya"
    },
    {
        id: "events",
        title: "Оформление мероприятий",
        description: "Свадьбы, корпоративы, дни рождения. Создадим цветочную атмосферу вашей мечты.",
        image: eventImg,
        icon: "🎉",
        features: ["Свадебная флористика", "Корпоративные мероприятия", "Полный цикл от идеи до реализации"],
        url: "/svadebnaya-floristika"
    }
];

export const MARCH_BANNER_CATEGORIES = [
    { id: 'Тюльпаны', name: 'Тюльпаны', description: 'Яркие, свежие и нежные', image: '🌷' },
    { id: 'Розы', name: 'Розы', description: 'Изысканные и запоминающиеся', image: '🌹' },
    { id: 'Лилии', name: 'Лилии', description: 'Стойкие с благородным ароматом', image: '🌺' },
    { id: 'Диантусы', name: 'Диантусы', description: 'Естественные и нежные', image: '🌸' },
    { id: 'Хризантемы', name: 'Хризантемы', description: 'Пышные и солнечные', image: '🌼' }
];

export const MARCH_BANNER_PRICE_RANGES = [
    { id: 'Эконом', label: 'Эконом', min: 500, max: 2000, icon: '🌱' },
    { id: 'Стандарт', label: 'Стандарт', min: 2000, max: 4000, icon: '🌸' },
    { id: 'Премиум', label: 'Премиум', min: 4000, max: 6000, icon: '🌹' },
    { id: 'Luxury', label: 'Luxury', min: 6000, max: 10000, icon: '👑' },
    { id: 'VIP', label: 'VIP', min: 10000, max: 50000, icon: '💎' }
];

export const INFO_CARDS = [
    { icon: "🌷", title: "Свежесть гарантируем", desc: "Только свежие цветы от проверенных поставщиков" },
    { icon: "🎁", title: "Открытка в подарок", desc: "При оформлении заказа через сайт" },
    { icon: "⏰", title: "Курьерская доставка", desc: "Доставим к указанному часу" }
];